export const flattenObjectToStringList = (obj: Record<string, any>) => {
    const result: string[] = [];
    Object.keys(obj).forEach(key => {
        if (typeof obj[key] === 'string') {
            result.push(obj[key]);
        } else if (typeof obj[key] === 'object') {
            result.push(...flattenObjectToStringList(obj[key]));
        }
    });
    return result;
};
